<template>
  <div class="box" v-if="chat" style="height: 100%">
    <div v-if="!isWidget" class="call">
      <div class="header">{{ chat.nick }}</div>
    </div>
    <div v-else class="accept-chat-header">
      <i @click="closeWindow" class="fas fa-arrow-left"></i>
    </div>
    <div class="acept-chat">  
      <div v-if="chat.status === 0" class="acept-chat__accept-chat-container"> 
        <img src="@/img/undraw_chat_1wo5.svg" />
        <div v-if="!chat.uid">
          <p v-if="!acceptingChats.includes(chat.roomId)">{{ $t("agent-console.click") }} <a href="" @click.prevent="acceptChat">{{ $t("agent-console.here") }}</a> {{ $t("agent-console.to-acept-the-chat-with", { name: chat.nick }) }} </p>
          <p v-else> {{ $t("agent-console.please-wait-while-the-chat-is-accepted") }} </p>
        </div>
        <div v-else>
          <p v-if="user.uid === chat.uid">{{ $t("agent-console.please-wait-while-the-chat-is-accepted") }} </p>
          <p v-else>{{ $t("agent-console.the-chat-has-already-been-accepted-by-another-agent")}}</p>
          <p> {{ $t("common.click") }} <a href="" @click.prevent="closeWindow">{{ $t("common.here") }}</a> {{ $t("common.to-close-this-window") }}</p>
        </div>
      </div>
      <div v-if="chat.status === 2" >
        <p>{{ $t("agent-console.the-chat-was-closed") }}</p>
        <p> {{ $t("common.click") }} <a href="" @click.prevent="closeWindow">{{ $t("common.here") }}</a> {{ $t("common.to-close-this-window") }}</p>
      </div>
      <div v-if="chat.status === 1">
        <p v-if="user.uid === chat.uid">{{ $t("agent-console.the-chat-was-assigned-to-you-open-it") }}</p>
        <p v-else> El chat fue aceptado por otro agente <br> {{ $t("common.click") }} <a href="" @click.prevent="closeWindow">{{ $t("common.here") }}</a> {{ $t("common.to-close-this-window") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "TheAcceptChatWindow",
  props: {
    isWidget:{
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    ...mapActions([
      "acceptPendingChat",
      "listenToAction",
      "removeAction",
    ]),
    acceptChat() {
      this.acceptPendingChat(this.chat);
      this.$emit('chatAccepted');
    },
    closeWindow() {
      this.$emit("closeWindow");
    }
  },
  computed: {
    chat() {
      return this.$store.getters['getPendingChatAccept'];
    },
    agent() {
      return this.$store.getters['getAgent'];
    },
    removed() {
      return this.chat ? this.chat.removed : false
    },
    user() {
      return this.$store.getters['getUser']
    },
    acceptingChats() {
      return this.$store.getters['getAcceptingChats']
    }
  },
  watch: {
    removed(value) {
      if (value) {
        this.$store.dispatch('fetchChatRemoved')
      }
    }
  }
};
</script>

<style scoped>
.main-content {
  height: 100%;
}

.main-content .title {
  color: var(--blue-grey);
}

.header {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

img {
  width: 20em;
}

.acept-chat {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 20%;
  text-align: center;
}
.acept-chat .acept-chat__accept-chat-container img{
  max-width: 300px;
}
</style>